import React from "react";

import "./styles.scss";
import ESGChatMain from "../esg-chat/esg-chat";

const FundResearchMain = () => {
    return (
        <div className="fund-research-main">
            <ESGChatMain
                searchType="Fund"
                showDisclosuresSection
            />
        </div>
    )
}

export default FundResearchMain